/* Alpaca · portada (capa 2C). Sin dependencias. Se carga diferido solo en la portada (snippets/alpaca-head).
   1) Contadores por sección (Supabase: portada_toques, función portada-toque). Sin datos personales.
   2) «Lo que miraste»: renglón compacto con las prendas que la persona ya miró (guardadas en su teléfono), con precio
      y stock de ahora; las saca de «Los que más se llevan» y las suma al mensaje de WhatsApp.
   3) Fecha límite de la ocasión de regalo, con el mismo motor de envío de la ficha (window.AlpacaEnvio).
   4) Promoción: a la hora de cierre (hora de Ecuador) se esconde la franja y el botón vuelve a ser el de siempre.
   5) Movimientos que se ven una sola vez: los mensajes de clientes entran uno tras otro y la tarjeta de regalo se
      asienta en su hilo. Sin ellos si el teléfono pide menos movimiento (lo resuelve el CSS).
   6) Primera pantalla: la etiqueta que cuelga, la nota a mano y la cinta de lugares las arma la propia sección
      (sections/alpaca-portada-inicio.liquid, con CSS y su guion); aquí solo se marca que este guion ya corrió.
   7) Filas de prendas: flechas en computadora.
   9) Filas sin fin: «Los que más se llevan» y «Lo que nos escriben» vuelven a empezar al deslizar.
   Todo se vuelve a armar si el editor de temas redibuja una sección (shopify:section:load). */
(function () {
  'use strict';
  var URL_T = 'https://efqmzvrxasvdigybsksf.supabase.co/functions/v1/portada-toque';
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var raizDoc = document.documentElement;
  /* En el editor de temas y en vistas previas de un tema sin publicar, los toques no se cuentan. */
  var contar = !(window.Shopify && (Shopify.designMode || (Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main')));

  /* Ancho real de la página sin la barra de desplazamiento (en computadora Horizon desplaza .page-wrapper):
     la retícula de la portada lo usa para alinear su borde con el del encabezado. */
  function anchoReal() {
    var pw = document.querySelector('.page-wrapper');
    var w = (pw && pw.clientWidth) || raizDoc.clientWidth;
    if (w) raizDoc.style.setProperty('--alp-vw', w + 'px');
  }
  anchoReal();
  window.addEventListener('resize', anchoReal);

  function cuandoLibre(fn) {
    if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 2500 });
    else setTimeout(fn, 600);
  }
  function cada(raiz, sel, fn) {
    if (raiz.matches && raiz.matches(sel)) fn(raiz);
    Array.prototype.forEach.call(raiz.querySelectorAll(sel), fn);
  }
  function ahoraEc() {
    var d = new Date(Date.now() - 5 * 3600e3);
    return { y: d.getUTCFullYear(), m: d.getUTCMonth(), d: d.getUTCDate(), dow: d.getUTCDay(), h: d.getUTCHours(), min: d.getUTCMinutes() };
  }
  function iso(f) { return f.toISOString().slice(0, 10); }
  function mas(f, n) { return new Date(f.getTime() + n * 864e5); }
  function alVerse(el, fn, margen) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(); } });
    }, { rootMargin: margen || '0px 0px -15% 0px' });
    io.observe(el);
  }

  /* 1) Contadores (un solo oyente para toda la página; la ocasión se lee al momento del toque) */
  var referente = '';
  try { var o = JSON.parse(localStorage.getItem('alpaca_origen') || 'null'); referente = (o && (o.utm_source || o.referente)) || ''; } catch (e) {}
  document.addEventListener('click', function (ev) {
    if (!contar) return;
    var a = ev.target && ev.target.closest ? ev.target.closest('[data-alp-t]') : null;
    if (!a) return;
    var ini = document.querySelector('.alp-ini');
    var ocasion = (ini && ini.getAttribute('data-alp-ocasion')) || '';
    var dest = a.getAttribute('href') || '';
    try { var u = new URL(dest, location.href); dest = u.hostname === location.hostname ? u.pathname : (u.hostname === 'wa.me' ? 'https://wa.me/' : ''); } catch (e) { dest = ''; }
    var datos = JSON.stringify({ s: a.getAttribute('data-alp-t'), d: dest, p: Number(a.getAttribute('data-alp-p') || 0), o: ocasion, r: String(referente).slice(0, 100) });
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(URL_T, new Blob([datos], { type: 'text/plain' }));
      else fetch(URL_T, { method: 'POST', body: datos, keepalive: true, mode: 'cors' });
    } catch (e) {}
  }, true);

  /* 6) Primera pantalla: el mecer de la etiqueta y la nota a mano son CSS puro de la sección, y el mecer al pasar el
     mouse y la cinta de lugares los arma el guion de la propia sección. Aquí solo queda la marca alp-ini--va (no hace
     falta esperar la letra: nada se pinta en dos tiempos). No falla si no encuentra nada. */
  function primeraPantalla(ini) {
    if (!ini || !ini.classList || ini.classList.contains('alp-ini--va')) return;
    ini.classList.add('alp-ini--va');
  }

  /* 2) Lo que miraste */
  var vistosNombres = [];
  function miraste(caja) {
    vistosNombres = [];
    var lista = caja.querySelector('[data-alp-miraste-lista]');
    var max = Number(caja.getAttribute('data-max') || 4);
    var vistos = [];
    try { vistos = JSON.parse(localStorage.getItem('alpaca_vistos') || '[]'); } catch (e) {}
    vistos = vistos.filter(function (h) { return typeof h === 'string' && /^[a-z0-9\-_%]+$/i.test(h); }).slice(0, max + 2);
    if (!vistos.length) { raizDoc.classList.remove('alp-vistos'); return; }
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Promise.all(vistos.map(function (h) {
      return fetch(raiz + 'products/' + encodeURIComponent(h) + '?section_id=alpaca-tarjeta-sola', { credentials: 'same-origin', priority: 'low' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (htmls) {
      var n = 0, rutas = [];
      lista.textContent = '';
      htmls.forEach(function (html) {
        if (!html || n >= max) return;
        /* <template>: el HTML se lee sin descargar sus imágenes. */
        var d = document.createElement('template');
        d.innerHTML = html;
        var t = d.content.querySelector('.alp-t');
        if (!t) return;
        var img = t.querySelector('.alp-t__img:not(.alp-t__img--2)');
        var nombre = t.querySelector('.alp-t__nombre');
        var tipo = t.querySelector('.alp-t__tipo');
        var precio = t.querySelector('.alp-t__precio b');
        var antes = t.querySelector('.alp-t__precio s');
        var a = document.createElement('a');
        a.className = 'alp-mi__item';
        a.href = t.getAttribute('href');
        a.setAttribute('data-alp-t', 'miraste');
        a.setAttribute('data-alp-p', String(n));
        var foto = document.createElement('span');
        foto.className = 'alp-mi__foto';
        if (img) {
          var im = document.createElement('img');
          im.alt = '';
          im.loading = 'lazy';
          im.width = 104; im.height = 130;
          if (img.getAttribute('srcset')) { im.srcset = img.getAttribute('srcset'); im.sizes = '(min-width: 990px) 104px, 64px'; }
          im.src = img.getAttribute('src');
          foto.appendChild(im);
        }
        var txt = document.createElement('span');
        txt.className = 'alp-mi__txt';
        var nom = document.createElement('span');
        nom.className = 'alp-mi__nombre';
        nom.textContent = (nombre ? nombre.textContent : '').trim();
        var pr = document.createElement('span');
        pr.className = 'alp-mi__precio';
        pr.textContent = precio ? precio.textContent.trim() : '';
        if (antes) {
          var s = document.createElement('s');
          var oculto = document.createElement('span');
          oculto.className = 'visually-hidden';
          oculto.textContent = 'Antes: ';
          s.appendChild(oculto);
          s.appendChild(document.createTextNode(antes.textContent.replace('Antes:', '').trim()));
          pr.appendChild(document.createTextNode(' '));
          pr.appendChild(s);
        }
        if (tipo) {
          var tp = document.createElement('span');
          tp.className = 'alp-mi__tipo';
          tp.textContent = tipo.textContent.split('·')[0].trim();
          txt.appendChild(tp);
        }
        txt.appendChild(nom);
        txt.appendChild(pr);
        a.appendChild(foto);
        a.appendChild(txt);
        var li = document.createElement('li');
        li.appendChild(a);
        lista.appendChild(li);
        rutas.push(a.pathname);
        var quien = ((tipo ? tipo.textContent.split('·')[0].trim().toLowerCase() + ' ' : '') + nom.textContent).trim();
        if (vistosNombres.indexOf(quien) < 0) vistosNombres.push(quien);
        n++;
      });
      if (!n) { raizDoc.classList.remove('alp-vistos'); return; }
      caja.hidden = false;
      var sec = caja.closest('[data-alp-miraste-sec]');
      if (sec) sec.hidden = false;
      /* La clase alp-vistos se queda: ya no reserva nada (las reglas miran [hidden]), pero esconde el WhatsApp de las
         puertas, que sobra cuando «Lo que miraste» ya lo ofrece. */
      /* Sin repetir: lo que ya miró sale de «Los que más se llevan» (si quedan al menos cuatro). */
      var fila = document.querySelector('.alp-pr [data-alp-fila]');
      if (fila) {
        var quitar = Array.prototype.filter.call(fila.children, function (li) {
          if (li.classList.contains('alp-pr__uno')) return false;
          var x = li.querySelector('a.alp-t');
          return x && rutas.indexOf(x.pathname) > -1;
        });
        if (fila.children.length - quitar.length >= 4) quitar.forEach(function (li) { li.remove(); });
        filaFlechas(fila);
      }
      whatsapp(document);
    });
  }

  /* WhatsApp: el mensaje ya escrito suma lo que la persona estaba mirando. */
  function whatsapp(raiz) {
    if (!vistosNombres.length) return;
    cada(raiz, '[data-alp-wa]', function (a) {
      try {
        var msg = a.getAttribute('data-alp-wa') + ' Estaba viendo: ' + vistosNombres.slice(0, 3).join(', ') + '.';
        a.href = a.href.split('?')[0] + '?text=' + encodeURIComponent(msg);
      } catch (e) {}
    });
  }

  /* 3) Fecha límite de la ocasión */
  function limite(sec) {
    var E = window.AlpacaEnvio;
    var el = sec.querySelector('[data-alp-limite]');
    var f = (sec.getAttribute('data-ocasion-fecha') || '').split('-');
    if (!E || !el || f.length !== 3) return;
    var fer = E.feriados();
    var nombre = sec.getAttribute('data-ocasion') || '';
    var esDia = /^D[ií]a/.test(nombre);
    var antes = (esDia ? 'antes del ' : 'antes de ') + nombre;
    var para = (esDia ? 'Para el ' : 'Para ') + nombre;
    function habil(d) { var w = d.getUTCDay(); return w >= 1 && w <= 5 && fer.indexOf(iso(d)) < 0; }
    var oc = new Date(Date.UTC(+f[0], +f[1] - 1, +f[2]));
    /* Que llegue el día hábil anterior a la ocasión, con un día de margen. */
    var meta = mas(oc, -1);
    while (!habil(meta)) meta = mas(meta, -1);
    meta = mas(meta, -1);
    while (!habil(meta)) meta = mas(meta, -1);
    /* Último día para pedir (cualquier día, a cualquier hora: sale al día siguiente) cuyo envío llega a tiempo. */
    var D = meta, ok = false;
    for (var k = 0; k < 30; k++) {
      var r = E.calcular(fer, { y: D.getUTCFullYear(), m: D.getUTCMonth(), d: D.getUTCDate(), dow: D.getUTCDay(), h: 12, min: 0 });
      if (r && r.lleg && r.lleg.getTime() <= meta.getTime()) { ok = true; break; }
      D = mas(D, -1);
    }
    var n = ahoraEc(), hoy = new Date(Date.UTC(n.y, n.m, n.d));
    var lugar = E.lugar ? E.lugar() : null;
    var txt = '';
    if (lugar && lugar.tipo === 'galapagos') {
      txt = 'A ' + lugar.nombre + ' tarda unos días más: escríbenos por WhatsApp para que llegue ' + antes + '.';
    } else if (ok && hoy.getTime() < D.getTime()) {
      var dif = Math.round((D - hoy) / 864e5);
      var mes = D.getUTCMonth() !== n.m ? ' de ' + MESES[D.getUTCMonth()] : '';
      var cual = (dif === 1 ? 'mañana, ' : 'el ') + DIAS[D.getUTCDay()] + ' ' + D.getUTCDate() + mes;
      txt = 'Para que llegue ' + antes + ', pídelo hasta ' + cual + '.';
    } else if (ok && hoy.getTime() === D.getTime()) {
      txt = 'Para que llegue ' + antes + ', pídelo hoy.';
    } else if (lugar && lugar.tipo === 'quito') {
      txt = para + ': en Quito, el mismo día.';
    }
    if (el.hasAttribute('data-alp-limite-base')) {
      /* Primera pantalla: la línea de siempre se queda si no hay fecha que decir. */
      if (txt) el.textContent = txt;
      return;
    }
    el.textContent = txt;
    el.hidden = !txt;
    el.classList.toggle('alp-re__limite--vacio', !txt);
  }
  /* La línea «En Quito, el mismo día.» sobra cuando la persona ya eligió Quito (el sello lo dice). */
  function quito(raiz) {
    var E = window.AlpacaEnvio;
    var lugar = E && E.lugar ? E.lugar() : null;
    cada(raiz, '[data-alp-quito]', function (p) { p.hidden = !!(lugar && (lugar.tipo === 'quito' || lugar.tipo === 'galapagos')); });
  }
  function envio(raiz) {
    cada(raiz, '[data-ocasion-fecha]', limite);
    quito(raiz);
  }
  window.addEventListener('alpaca:ciudad', function () { envio(document); });
  /* El motor de envío llega con los guiones de los bloques: si todavía no estaba, se calcula al terminar de cargar. */
  if (!window.AlpacaEnvio) window.addEventListener('load', function () { envio(document); });

  /* 4) Promoción: cierre a la hora exacta */
  function promo(raiz) {
    cada(raiz, '[data-alp-fin]', function (p) {
      var v = p.getAttribute('data-alp-fin') || '';
      var t = /^\d+$/.test(v) ? Number(v) : Date.parse(v);
      if (isNaN(t)) return;
      var cerrar = function () {
        if (p.tagName === 'A') {
          var txt = p.getAttribute('data-alp-txt'), url = p.getAttribute('data-alp-url');
          if (txt) p.textContent = txt;
          if (url) p.setAttribute('href', url);
          p.removeAttribute('data-alp-fin');
          var ini = p.closest('.alp-ini');
          if (ini) ini.classList.remove('alp-ini--promo');
        } else {
          p.hidden = true;
        }
      };
      var falta = t - Date.now();
      if (falta <= 0) cerrar();
      else if (falta < 864e5) setTimeout(cerrar, falta);
    });
  }

  /* 5) Movimientos de una sola vez */
  function chats(el) {
    if (el.classList.contains('alp-chats--llegan')) return;
    el.classList.add('alp-chats--espera');
    alVerse(el, function () { el.classList.add('alp-chats--llegan'); });
  }
  function regalo(sec) {
    var c = sec.querySelector('.alp-re__colgante');
    if (!c || c.classList.contains('alp-re__colgante--va')) return;
    alVerse(c, function () { c.classList.add('alp-re__colgante--va'); }, '0px 0px -25% 0px');
  }

  /* 7) Flechas de las filas (solo se ven en computadora) */
  function filaFlechas(fila) {
    var sec = fila.closest('.alp-pr');
    if (!sec) return;
    var btns = sec.querySelectorAll('[data-alp-fila-ir]');
    var fin = fila.scrollWidth - fila.clientWidth - 2;
    /* aria-disabled y no disabled: el foco del teclado no se pierde cuando la fila llega al final. */
    Array.prototype.forEach.call(btns, function (b) {
      var dir = Number(b.getAttribute('data-alp-fila-ir'));
      b.setAttribute('aria-disabled', String(dir < 0 ? fila.scrollLeft <= 2 : fila.scrollLeft >= fin));
    });
    sec.classList.toggle('alp-pr--sin-flechas', fin <= 2);
  }
  function fila(f) {
    if (f.getAttribute('data-alp-fila-va')) return;
    f.setAttribute('data-alp-fila-va', '1');
    var sec = f.closest('.alp-pr');
    var espera;
    f.addEventListener('scroll', function () { clearTimeout(espera); espera = setTimeout(function () { filaFlechas(f); }, 80); }, { passive: true });
    if (sec) {
      Array.prototype.forEach.call(sec.querySelectorAll('[data-alp-fila-ir]'), function (b) {
        b.addEventListener('click', function () {
          if (b.getAttribute('aria-disabled') === 'true') return;
          var paso = f.clientWidth + parseFloat(getComputedStyle(f).columnGap || 0);
          f.scrollBy({ left: Number(b.getAttribute('data-alp-fila-ir')) * paso, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });
    }
    window.addEventListener('resize', function () { filaFlechas(f); });
    filaFlechas(f);
  }

  /* 8) Movimientos que pasan una sola vez, al aparecer (etiquetas de las puertas, franja tejida, 70 %, fecha,
     nota a mano). Solo agregan una clase; el movimiento es del estilo. El número cuenta desde cero recién cuando
     aparece, con punto de miles (2.825) y en su ancho final, para que el texto de al lado no se mueva. */
  function miles(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function cuenta(el) {
    var fin = Number(el.getAttribute('data-alp-cuenta')) || 0;
    /* Pestaña en segundo plano o movimiento reducido: se queda el número real que ya trae el HTML. */
    if (!fin || matchMedia('(prefers-reduced-motion: reduce)').matches || document.hidden) return;
    var listo = false, t0 = -1, dur = fin > 500 ? 1900 : 1100;
    /* Red de seguridad: si en 3 s el conteo no terminó (requestAnimationFrame frenado), queda el valor final. */
    var seguro = setTimeout(function () { if (!listo) { listo = true; el.textContent = miles(fin); } }, 3000);
    /* El 0 lo pone recién el primer cuadro, cuando el número ya está a la vista y empieza a contar. */
    requestAnimationFrame(function paso(t) {
      if (listo) return;
      if (t0 < 0) t0 = t;
      var x = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - x, 3);
      el.textContent = miles(Math.round(fin * e));
      if (x < 1) requestAnimationFrame(paso);
      else { listo = true; clearTimeout(seguro); }
    });
  }
  function mueve(el) {
    if (el.classList.contains('alp-va')) return;
    /* «armado»: el guion se hace cargo, así que la red de seguridad del estilo (que lo dibuja a los 6 s) se apaga y el
       elemento espera vacío hasta aparecer. Sin esto, quien llegaba después de 6 s lo veía lleno, vacío y otra vez lleno. */
    el.classList.add('alp-armado');
    var c0 = el.querySelector('[data-alp-cuenta]');
    /* Mientras espera, el número real queda escrito (nunca «0»); solo se fija su ancho para que nada salte al contar. */
    if (c0 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var ancho = c0.getBoundingClientRect().width;
      if (ancho) { c0.style.display = 'inline-block'; c0.style.minWidth = Math.ceil(ancho) + 'px'; c0.style.textAlign = c0.getAttribute('data-alp-alinea') === 'izq' ? 'left' : 'right'; }
    }
    alVerse(el, function () {
      el.classList.add('alp-va');
      var n = el.querySelector('[data-alp-cuenta]');
      if (n) cuenta(n);
    }, '0px 0px -12% 0px');
  }

  /* 9) Filas sin fin ([data-alp-sin-fin]: «Los que más se llevan» y «Lo que nos escriben»). Se agregan dos copias de
     la lista (antes y después), ocultas para lectores de pantalla y fuera del orden del teclado, y la fila arranca en
     la del medio. Cuando la persona deja de deslizar (scrollend o una pausa), si quedó en una copia de los bordes se
     la devuelve al mismo punto de la del medio: es idéntico, así que el salto no se ve. Nada se mueve solo. */
  function sinFin(f) {
    if (f.getAttribute('data-alp-sin-fin-va')) return;
    var orig = Array.prototype.slice.call(f.children);
    if (orig.length < 3) return;
    f.setAttribute('data-alp-sin-fin-va', '1');
    orig.forEach(function (li) { li.setAttribute('data-alp-copia', '1'); });
    function copia(n) {
      var frag = document.createDocumentFragment();
      orig.forEach(function (li) {
        var c = li.cloneNode(true);
        c.setAttribute('data-alp-copia', String(n));
        c.setAttribute('aria-hidden', 'true');
        Array.prototype.forEach.call(c.querySelectorAll('a, button, input, [tabindex]'), function (x) { x.setAttribute('tabindex', '-1'); });
        Array.prototype.forEach.call(c.querySelectorAll('[id]'), function (x) { x.removeAttribute('id'); });
        /* «la más pedida» va solo en la primera real */
        Array.prototype.forEach.call(c.querySelectorAll('.alp-t__nota'), function (x) { x.parentNode.removeChild(x); });
        frag.appendChild(c);
      });
      return frag;
    }
    f.insertBefore(copia(0), f.firstChild);
    f.appendChild(copia(2));
    function ancho() {
      var a = f.querySelector('[data-alp-copia="0"]'), b = f.querySelector('[data-alp-copia="1"]');
      return a && b ? b.offsetLeft - a.offsetLeft : 0;
    }
    function mover(x) {
      var antes = f.style.scrollBehavior;
      f.style.scrollBehavior = 'auto';
      f.scrollLeft = x;
      f.style.scrollBehavior = antes;
    }
    function centrar() {
      var w = ancho();
      if (!w) return;
      var x = f.scrollLeft;
      if (x < w * 0.5) mover(x + w);
      else if (x >= w * 1.5) mover(x - w);
    }
    mover(f.scrollLeft + ancho());
    var tocando = false, espera = 0;
    f.addEventListener('touchstart', function () { tocando = true; }, { passive: true });
    f.addEventListener('touchend', function () { tocando = false; }, { passive: true });
    f.addEventListener('touchcancel', function () { tocando = false; }, { passive: true });
    if ('onscrollend' in window) {
      f.addEventListener('scrollend', function () { if (!tocando) centrar(); });
    } else {
      f.addEventListener('scroll', function () {
        clearTimeout(espera);
        espera = setTimeout(function () { if (!tocando) centrar(); }, 220);
      }, { passive: true });
    }
    window.addEventListener('resize', function () { clearTimeout(espera); espera = setTimeout(centrar, 200); });
  }

  function iniciar(raiz) {
    cada(raiz, '.alp-ini', primeraPantalla);
    promo(raiz);
    if (window.AlpacaEnvio) envio(raiz);
    cada(raiz, '[data-alp-chats]', chats);
    cada(raiz, '[data-alp-regalo]', regalo);
    cada(raiz, '[data-alp-mueve]', mueve);
    cada(raiz, '[data-alp-sin-fin]', sinFin);
    cada(raiz, '[data-alp-fila]', fila);
    /* «Lo que miraste» se pide enseguida: el espacio reservado se llena antes de que la persona llegue ahí. */
    cada(raiz, '[data-alp-miraste]', miraste);
    cuandoLibre(function () { whatsapp(raiz); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  else iniciar(document);
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
